var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8404 11.0457L9.44066 8.6596C10.0849 7.80806 10.428 6.65266 10.4548 5.20705C10.3975 1.88214 8.54165 0.0393987 5.22438 0.0175781C1.86729 0.0388531 0 1.98797 0 5.2065C0 8.58596 1.86893 10.3954 5.23093 10.4151C6.66508 10.4063 7.81612 10.0736 8.6693 9.43041L11.0712 11.8192C11.3538 12.0876 11.6882 11.978 11.8426 11.817C12.0515 11.5999 12.0542 11.2579 11.8404 11.0457ZM1.09103 5.21632C1.14394 2.46966 2.49791 1.12552 5.22384 1.10861C7.92358 1.12606 9.31682 2.51112 9.36374 5.2065C9.31246 7.99953 7.99723 9.30767 5.23093 9.32404C2.46136 9.30767 1.14558 8.0028 1.09103 5.21632Z",
    fill: "#234492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/Searchicon.8ae48892f85c969bd2c8d54fdedae465.svg";
export { ForwardRef as ReactComponent };